import React from 'react';
import PropTypes from 'prop-types';
import { TimeField } from 'lib';
import { useTimeSettingsFormat } from 'common/useTimeSettingsFormat';
import { DAY_PART, convertTimeObject, convertTo24HourFormat } from 'common/dateFormatConfig';

const stringOrNumber = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

const TimeInput = ({ value, onChange, disabled, error, className }) => {
  const { is12Format } = useTimeSettingsFormat()();
  const { hour, minute, amPm } = value;

  const time = {
    hour: parseInt(is12Format ? convertTo24HourFormat(hour, amPm) : hour, 10),
    minute: parseInt(minute, 10),
  };
  const isEmpty =
    Number.isNaN(time.hour + time.minute) || (is12Format && !DAY_PART.includes(amPm));

  // 24-hour organizations never edit the period, so it goes back as it came.
  const handleChange = (next) =>
    onChange({
      ...convertTimeObject({ ...next, minute: String(next.minute).padStart(2, '0') }, is12Format),
      ...(!is12Format && { amPm }),
    });

  return (
    <TimeField
      value={isEmpty ? null : time}
      onChange={handleChange}
      hour12={is12Format}
      disabled={disabled}
      error={error}
      className={className}
    />
  );
};

TimeInput.propTypes = {
  value: PropTypes.shape({
    hour: stringOrNumber,
    minute: stringOrNumber,
    amPm: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  className: PropTypes.string,
};

TimeInput.defaultProps = {
  value: {},
};

export default TimeInput;
